import { GeschaeftspartnerDetailPage } from "@/pages/kontakte/GeschaeftspartnerDetailPage";

export function KundeDetailPage() {
  return (
    <GeschaeftspartnerDetailPage
      typ="kunde"
      listPath="/kontakte/kunden"
      listLabel="Kunden"
    />
  );
}
